export default "__VITE_ASSET__CGgUKyaB__"